<template>
    <div class="col-md-9">
        <div class="row">
            <table class="table">
                <thead>
                    <tr>
                        <th class="col-md-1">Изображение</th>
                        <th class="col-md-2">Название</th>
                        <th class="col-md-3">Код оплаты (Из документации)</th>
                        <th class="col-md-1">Сортировка</th>
                        <th class="col-md-2">Активность</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="selected_method in selected_methods">
                        <td>
                            <img :src="'/' + selected_method.previewFilePath">
                        </td>
                        <td v-text="selected_method.name"></td>
                        <td>
                            <input type="text"
                                   class="form-control"
                                   :name="`payment_methods[${selected_method.id}][code]`"
                                   :value="isset(selected_method.pivot) ? selected_method.pivot.code : ''"
                                   :disabled="!has_permission_to_attach_methods"
                            >
                        </td>
                        <td>
                            <input type="number"
                                   class="form-control"
                                   :name="`payment_methods[${selected_method.id}][sorting]`"
                                   :value="isset(selected_method.pivot) ? selected_method.pivot.sorting : 0">
                        </td>
                        <td>
                            <label>
                                <input type="checkbox"
                                       value="1"
                                       :name="`payment_methods[${selected_method.id}][is_active]`"
                                       :checked="isset(selected_method.pivot) ? selected_method.pivot.is_active : 0">
                                Отображать?
                            </label>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="form-group" v-if="has_permission_to_attach_methods">
            <button type="button" class="btn btn-primary" @click="openModal">
                Выбрать методы оплаты
            </button>
        </div>

         <!--MODAL -->
        <div class="modal vue-modal product-consumables__modal" v-if="is_visible_modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" @click="closeModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">Выбор методов оплаты</h4>
                    </div>
                    <div class="modal-body">
                        <table-items inline-template
                             :columns="columns"
                             :default_sort_key="default_sort_key"
                             :default_sort_order="default_sort_order"
                             :current_route="current_route"
                             :fixed_table="fixed_table"
                             :default_checked="checked_ids"
                        >
                            <table class="table table-bordered b-admin-table" id="similar_products_table">
                                <thead>
                                    <tr>
                                        <th class="no-sort b-admin-table__selectall">
                                            <input type="checkbox" v-model="all_selected" @mousedown="select_all()" />
                                        </th>
                                        <th v-for="key in columns" :class="'col-md-' + key.width">
                                            <div
                                                    v-if="key.nosort !== true"
                                                    @click="sortBy(key.code)"
                                                    :class="{active: sort_key == key.code}"
                                                    class="sortable"
                                            >
                                                <span v-html="key.label"></span>
                                                <span class="arrow">
                                                    <i :class="'fa fa-sort-' + sort_order[key.code]"></i>
                                                </span>
                                            </div>
                                            <div
                                                    v-else
                                                    v-html="key.label"
                                            >
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="table.total > 0" v-for="item in table.data">
                                        <td class="no-sort">
                                            <input
                                                    type="checkbox"
                                                    :value="item.id"
                                                    v-model="checked"
                                                    :data-id="item.id"
                                                    :data-name="item.name || item.title"
                                                    @click.shift="select_range(item.id)"
                                            />
                                        </td>
                                        <td>
                                            <span
                                                    class="b-product-table__product-id"
                                                    v-html="item.id"
                                            >
                                            </span>
                                        </td>
                                        <td v-html="item.name"></td>
                                    </tr>
                                    <tr v-if="table.total == 0">
                                        <td colspan="6" class="b-admin-table__no-results">
                                            {{ trans('articles/admin.not_found') }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </table-items>

                        <table-pagination
                             :current_route="current_route"
                        ></table-pagination>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default pull-right" @click="closeModal">Закрыть</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['default_selected_methods', 'has_permission_to_attach_methods'],
        created: function () {
            this.$root.$on('update:checked', (ids) => { this.checked_ids = ids; });
            this.$root.$on('update:table', (table_data) => { this.table_data = table_data.data; });
        },
        data: function () {
            return {
                table_data: [],
                is_visible_modal: false,

                // DATA FOR MODAL TABLE
                fixed_table: false,
                counter_enabled: true,
                default_sort_key: 'id',
                default_sort_order: 'desc',
                checked_ids: this.getDefaultCheckedIds(),
                current_route: '/shop/payments/payment_methods',
                columns: [
                    {code: 'id', width: 1, label: 'id'},
                    {code: 'name', width: 11, label: 'Название', m_width: 8},
                ]
            };
        },
        methods: {
            isset: function (variable) {
                return typeof variable !== 'undefined';
            },
            openModal: function () {
                this.is_visible_modal = true;
            },
            closeModal: function () {
                this.is_visible_modal = false;
            },
            getDefaultCheckedIds: function () {
                let checked = [];
                for (let i = 0; i < this.default_selected_methods.length; i++) {
                    checked.push(this.default_selected_methods[i].id);
                }

                return checked;
            },
            findInDefaultsById: function (id) {
                for (let i = 0; i < this.default_selected_methods.length; i++) {
                    if (this.default_selected_methods[i].id === id) {
                        return this.default_selected_methods[i];
                    }
                }

                return false;
            },
            findInTableDataById: function (id) {
                for (let i = 0; i < this.table_data.length; i++) {
                    if (this.table_data[i].id === id) {
                        return this.table_data[i];
                    }
                }

                return false;
            },
        },
        computed: {
            selected_methods: function () {
                let selected_methods = [];
                for (let i = 0; i < this.checked_ids.length; i++) {
                    let defaultMethod = this.findInDefaultsById(this.checked_ids[i]);

                    if (defaultMethod) {
                        selected_methods.push(defaultMethod);
                        continue;
                    }

                    selected_methods.push(this.findInTableDataById(this.checked_ids[i]));
                }

                return selected_methods;
            }
        },
    };
</script>
